<template>
  <div id="app">
    <router-view v-if="$route.meta.requiresAuth && isAuthenticated"></router-view>
    <router-view v-else-if="!$route.meta.requiresAuth"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isAuthenticated: localStorage.getItem('isAuthenticated') === 'true'
    }
  },
  watch: {
    $route(to, from) {
      this.isAuthenticated = localStorage.getItem('isAuthenticated') === 'true'
      if (to.meta.requiresAuth && !this.isAuthenticated) {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
}
</style>


// WEBPACK FOOTER //
// src/App.vue